import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormControl } from '@angular/forms';

import { debounceTime, Subject, takeUntil } from 'rxjs';

import { trackByProp } from '@recruitee/common';
import { TranslatePipe } from '@recruitee/i18n';
import {
  ButtonComponent,
  ButtonDropdownIndicatorDirective,
  ConnectedOverlayDirective,
  DividerComponent,
  DropdownComponent,
  DropdownHeaderComponent,
  DropdownItemComponent,
  FormFieldComponent,
  IconComponent,
  InputComponent,
  OverlayOriginDirective,
  RtTooltip,
} from '@recruitee/user-interface';

import { FlowSelectOption } from '../../requisitions.types';

@Component({
  selector: 'rt-requisitions-flow-select',
  templateUrl: './requisitions-flow-select.component.html',
  styleUrls: ['./requisitions-flow-select.component.less'],
  standalone: true,
  imports: [
    ButtonComponent,
    ButtonDropdownIndicatorDirective,
    ConnectedOverlayDirective,
    DividerComponent,
    DropdownComponent,
    DropdownHeaderComponent,
    DropdownItemComponent,
    FormFieldComponent,
    IconComponent,
    InputComponent,
    OverlayOriginDirective,
    RtTooltip,
    TranslatePipe,
  ],
})
export class RequisitionsFlowSelectComponent {
  @Input() public isDisabled: boolean;
  @Input() public options: FlowSelectOption[];
  @Input() public selectedOption?: FlowSelectOption;

  @Output() public select = new EventEmitter<FlowSelectOption>();

  public hasSearch = false;
  public visibleOptions: FlowSelectOption[] = [];
  public searchControl = new FormControl('', { nonNullable: true });
  public trackByValue = trackByProp<{ value: string | number | null }>({ prop: 'value' });
  private ngOnDestroy$ = new Subject<void>();

  constructor(private cdRef: ChangeDetectorRef) {}

  public ngOnInit() {
    this.searchControl.valueChanges
      .pipe(debounceTime(100), takeUntil(this.ngOnDestroy$))
      .subscribe(() => this.filterOptions());
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.options?.currentValue) {
      this.visibleOptions = [...this.options];
      this.hasSearch = this.options.length >= 6;
    }
  }

  public ngOnDestroy() {
    this.ngOnDestroy$.next();
    this.ngOnDestroy$.complete();
  }

  private filterOptions() {
    const query = this.searchControl.value.toLowerCase();
    this.visibleOptions = this.options.filter(option => option.label.toLowerCase().includes(query));
    this.cdRef.detectChanges();
  }
}
